<template>
  <BaseModal modal-content-class="modal-achievement locked modal_glow2">
  <div>
    <!-- use the classes for rest of the levels -->
    <div class="banner_top"
         v-bind:class="currentImageClass(achievement)"
         v-bind:style="{ filter: achievement.completed ?  'none' : 'blur(3px)'}"></div>
    <div class="content">
      <div class="ach_modal_center">
        <base-image :src="getAchievementImagePath(achievement)" type-for-skin="achievement"/>
      </div>
      <h1>{{getTranslations[`achievement_${achievement.achievementName}`]}}</h1>

      <div class="unlocked_txt" v-if="checkIfStreak(achievement)">
        <p>{{ getTranslations.achievement_modal_streak_play  }} <b>{{  calculatePrizeThreshold(achievement)}}</b> {{ getTranslations.achievement_modal_streak_days
          }} <b>{{ calculatePrizePoints(achievement) }}</b> {{ getTranslations.achievement_modal_points
          }}</p>
      </div>

      <div class="unlocked_txt" v-if="checkIfAchievementWithCorrectAnswersInRow(achievement)">
        <p>{{ getTranslations.achievement_modal_achievement_answer  }} <b>{{  calculatePrizeThreshold(achievement)}}</b> {{ getTranslations.achievement_modal_achievement_questions_correct_in_row
          }} <b>{{ calculatePrizePoints(achievement) }}</b> {{ getTranslations.achievement_modal_points
          }}</p>
      </div>

      <div class="unlocked_txt" v-if="checkIfAchievement(achievement)">
        <p>{{ getTranslations.achievement_modal_achievement_answer  }} <b>{{  calculatePrizeThreshold(achievement)}}</b> {{ getTranslations.achievement_modal_achievement_questions_correct
          }} <b>{{ calculatePrizePoints(achievement) }}</b> {{ getTranslations.achievement_modal_points
          }}</p>
      </div>

      <div class="unlocked_txt" v-if="checkIfWarrior(achievement)">
        <p>{{ getTranslations.achievement_modal_achievement_play  }} <b>{{  calculatePrizeThreshold(achievement)}}</b> {{ getTranslations.achievement_modal_achievement_games
          }} <b>{{ calculatePrizePoints(achievement) }}</b> {{ getTranslations.achievement_modal_points
          }}</p>
      </div>
      <div class="unlocked_txt" v-if="checkIfLevel(achievement)">
        <p>{{ getTranslations.achievement_modal_unlock  }} <b>{{  calculatePrizeThreshold(achievement)}}</b> {{ getTranslations.achievement_modal_points_and_rewards
          }} <b>{{ calculatePrizePoints(achievement) }}</b> {{ getTranslations.achievement_modal_points
          }}</p>
      </div>


      <p
        v-if="shouldShowProgress(achievement)"
        class="progress_numb">{{ calculateProgress(achievement)}}%
      </p>
      <div
        v-if="shouldShowProgress(achievement)"
        class="progress-container">
        <div
          class="progress-bar"
          :style="{ width: calculateProgress(achievement) + '%' }"
        ></div>
      </div>

      <div class="gift_points_box">
        <div class="header">{{ getTranslations.achievement_modal_reward
          }}</div>
        <div class="flex-row">
          <p class="points">{{ calculatePrizePoints(achievement) }}</p>
          <img src="/static/images/home/points_star.png">
        </div>
      </div>

    </div>
  </div>
  </BaseModal>
</template>

<script>
import {mapGetters} from "vuex";
import BaseModal from "../../common/modal/BaseModal";
import BaseImage from '../../common/image/BaseImage.vue';

export default {
  components: {
    BaseModal,
    BaseImage,
  },
  props: {
    achievement: {
      type: Object,
      default:  () => ({})
    }
  },
  data() {
    return {
      isStreak: false,
      isLevel: false,
      levels: [
        "SCHOOL_OF_LIFE",
        "LIBRARY_OF_KNOWLEDGE",
        "HOUSE_OF_WISDOM",
        "MINISTRY_OF_FUTURE"
      ],
      achievementList: [
        "A_STUDENT",
        "BIG_BRAIN"
      ]
    };
  },
  methods: {
    getAchievementImagePath(achievement) {
      console.log('Achievement:::: ',achievement)
      const isLocked = achievement.completed ? 'unlocked' : 'locked';
      return `static/images/achievements/${achievement.achievementName}_${isLocked}.png`;
    },

    currentImageClass(achievement) {
      return achievement.achievementName;
    },

    calculateProgress(achievement) {
      // Calculate progress based on the achievement object
      if (achievement.completed) {
       return 100;
      } else {
        return achievement.percentage || 0; // Fallback to 0 if percentage is undefined
      }
    },

    calculatePrizePoints(achievement){
      return achievement.prizeValue || 0;
    },

    calculatePrizeThreshold(achievement){
      return achievement.threshold || 0;
    },
    checkIfStreak(achievement) {
      return achievement && achievement.achievementName
        ? achievement.achievementName.toUpperCase().includes("STREAK")
        : false;
    },
      shouldShowProgress(achievement) {
        if (!achievement || !achievement.achievementName) return false;
        var isInLevels = this.levels.includes(achievement.achievementName);
        return !isInLevels || achievement.completed === true;
      },

    checkIfAchievementWithCorrectAnswersInRow (achievement) {
      return achievement && (achievement.achievementName === 'TURBO_BRAIN');
    },

    checkIfLevel(achievement) {
      return achievement &&
        achievement.achievementName &&
        this.levels.includes(achievement.achievementName);
    },

    checkIfAchievement(achievement) {
      return achievement &&
        achievement.achievementName &&
        this.achievementList.includes(achievement.achievementName);
    },

    checkIfWarrior(achievement) {
      return achievement && achievement.achievementName
        ? achievement.achievementName.toUpperCase().includes("WARRIOR")
        : false;
    },

  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  }

}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/AchievementModal.vue